import api from './api';

export async function enviaContato(Nome,Celular,Mensagem) {
    const response = await api.post('/contato', { Nome,Celular,Mensagem });
    return response.data;
}
